import PATH from "./params";
import React from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import LoginScreen from "../pages/Auth/Login/LoginScreen";
import PrivateRoutes from "../pages/Auth/privateRoutes/PrivateRoutes";
import MainLayout from "../components/MainLayout/MainLayout";
import CheckYourEmail from "../pages/Auth/PasswordReset/CheckYourEmail";
import ChangePassword from "../pages/Auth/PasswordReset/ChangePassword";

export const Router = createBrowserRouter([
  {
    path: PATH.HOME,
    element: <PrivateRoutes Component={MainLayout} />,
    children: PATH.MENU.map((menuItem) => {
      if(menuItem.children){
        return {
          path: menuItem.path,
          element: menuItem.element,
          children: menuItem.children.map((child) => {
            return {
              path: child.path,
              element: child.element,
            };
          }),
        };
      }
      return {
        path: menuItem.path,
        element: menuItem.element,
      };
    }),
  },
  {
    path: PATH.LOGIN,
    element: <LoginScreen />,
  },
  {
    path: PATH.CHECK_EMAIL,
    element: <CheckYourEmail />,
  },
  {
    path: PATH.PASSWORD_RESET,
    element: <ChangePassword />,
  },
]);

const RouterWrapper = () => {
  return (
    <>
      <RouterProvider router={Router} />
    </>
  );
};

export default RouterWrapper;
